import { graphql } from 'gatsby';

import React, { useRef } from 'react';
import { SanityImageType } from '../../../graphql-fragments/SanityImage';
import { CommonModuleProps } from '../../ModulesContent';
import AnimatedTitle from '../AnimatedTitle';
import Image from '../Image';
import ModuleLayout from '../ModuleLayout';
import ScrollingItems from '../ScrollingItems';
import * as styles from './LogosModule.module.scss';

const ELEMENT_ANIMATION_DURATION = 10;

export const LogosModuleFragment = graphql`
  fragment LogosModule on SanityLogosModule {
    title {
      ...LocaleStringFragment
    }
    logos {
      lightLogo {
        ...SanityImage
      }
      darkLogo {
        ...SanityImage
      }
    }
  }
`;

export type LogosModuleProps = {
  title?: string;
  logos: Array<{
    lightLogo: SanityImageType;
    darkLogo: SanityImageType;
  }>;
  className?: string;
};

function LogosModule(props: LogosModuleProps & CommonModuleProps): React.ReactElement {
  const { title, logos, className, moduleId } = props;
  const containerRef = useRef<HTMLElement | null>(null);

  return (
    <ModuleLayout
      id={moduleId}
      ref={containerRef}
      className={className}
      childrenClassName={styles.contentContainer}
      currentModuleBgColor={props.theme}
      childrenWithoutHorizontalPadding
    >
      {title && (
        <div className={styles.titleContainer}>
          <AnimatedTitle title={title} trigger={styles.contentContainer} className={styles.title} />
        </div>
      )}
      <ScrollingItems
        animationDirection="left"
        animationDuration={ELEMENT_ANIMATION_DURATION * logos.length + 1}
        className={styles.scrollingWrapper}
      >
        <div className={styles.logosContainer}>
          {logos.map((logo, i) => (
            <div className={styles.logoContainer} key={i}>
              <Image
                className={styles.logo}
                image={
                  props.theme === 'moonlit' || props.theme === 'starlit'
                    ? logo.lightLogo
                    : logo.darkLogo
                }
                eagerLoading
              />
            </div>
          ))}
        </div>
      </ScrollingItems>
    </ModuleLayout>
  );
}

export default LogosModule;
